import React from 'react'
import Container from 'reactstrap/es/Container'

const Legislation = ({...props}) => {
  return <Container></Container>
}

export default Legislation
